import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import usePageLoaded from '../../hooks/usePageLoaded'

import NotificationsTabs from '../../components/notifications/NotificationsTabs'
import List from '../../components/notifications/List'
import Title from '../../components/ui/title/title'

import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'

import { checkAuth } from '../../utils/auth'
import { getLangFromPath, getPrefixFromPath } from '../../i18next'
import paths from '../../paths'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMemberNotifications } from '../../store/member/memberSlice'
import { RootState } from '../../store/rootReducer'
import { SingleNotificationInList } from '../../store/member/memberTypings'
import { useInfiniteScroll } from '../../hooks/useInfiniteScroll'

const NotificationsList: React.FunctionComponent = () => {
    usePageLoaded()

    const dispatch = useDispatch()

    const [t] = useTranslation()
    const location = useLocation()
    const userNotifications = useSelector<RootState, SingleNotificationInList[]>(
        (state) => state.member.userNotifications
    )
    const currentPageOfNotifications = useSelector<RootState, number>(
        (state) => state.member.currentPageOfNotifications
    )
    const userNotificationsTotal = useSelector<RootState, number>((state) => state.member.userNotificationsTotal)

    const [currentPage, setCurrentPage] = useState(1)
    const [isListEnded, setIsListEnded] = useState(true)

    const isListNotEnded = () => userNotificationsTotal / 20 > currentPage || !userNotificationsTotal

    useEffect(() => {
        if (currentPage > currentPageOfNotifications && isListNotEnded())
            dispatch(fetchMemberNotifications({ p: currentPage }))
        setIsListEnded(!isListNotEnded())
    }, [currentPage])

    const triggerRef = useRef(null)

    useInfiniteScroll({ callback: () => setCurrentPage((prev) => prev + 1), triggerRef })

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.notifications[getLangFromPath(location.pathname)].title}</title>
                <meta name="description" content={META.notifications[getLangFromPath(location.pathname)].description} />
            </Helmet>
            <Title text={t('Notification services')} />
            <Title text={t('notificationsDescription')} secondary />
            <NotificationsTabs />
            <List notifications={userNotifications} trigger={triggerRef} isListEnded={isListEnded} />
        </div>
    )
}

// @ts-ignore
NotificationsList.getInitialProps = async ({ req, store }) => {
    await checkAuth(store)
    const {
        member: { loggedIn }
    } = store.getState()

    if (!loggedIn)
        return {
            redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${paths.notificationList.path}`
        }
}

export default NotificationsList
